import React from 'react';
import { CheckIcon } from 'lucide-react';
import { audience } from '../data/content';
export function Audience() {
  return <section className="w-full bg-cream" data-id="element-20" data-mp="3p1nr9voqonu2">
      <div className="mx-auto max-w-content px-5 py-16 lg:px-8 lg:py-24" data-id="element-21" data-mp="3p2p4o6t89mey">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.3fr] lg:gap-20" data-id="element-22" data-mp="6w0zyi23b19t">
          <div data-id="element-23" data-mp="1ulbeg0pecmo">
            <h2 className="font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-24" data-mp="1u3a34z6p87w">
              Este sistema puede ayudarte si…
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-ink-muted" data-id="element-25" data-mp="bucbcx819ju5">
              No hace falta que tengas orden previo ni experiencia con
              presupuestos. El punto de partida es tu situación actual, tal como
              está hoy.
            </p>
          </div>

          <ul className="grid gap-x-10 gap-y-4 sm:grid-cols-2" data-id="element-26" data-mp="zjeqnyf730lh">
            {audience.map(item => <li key={item} className="flex items-start gap-3 text-base text-ink" data-id="element-27" data-mp="zh27jhxpak6u">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-forest" aria-hidden="true" data-id="element-28" data-mp="ui7g5rlo3nb4" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}